<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.projectName" label="物业项目名称" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.planTypeLabel" label="任务类型" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
<!--        <van-field v-model="inputForm.questionEndDate" label="整改期限" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>-->

        <van-field v-model="inputForm.planName" label="任务计划" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.standardName" label="检查标准" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.standardModuleName" label="检查模块" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.inspectionItemName" label="检查类别" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.questionDesc" label-width='100px' rows="1" autosize label="问题描述" type="textarea" placeholder="问题描述"
                   readonly input-align="left" :border="false"/>
<!--        <van-field v-model="inputForm.planName" label="任务计划" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>-->
        <van-field label="问题图片" readonly />
        <div style="display: flex; padding-left: 16px">
          <van-image v-for="(item, index) in questionPic" :key="item.id" width="100px" height="100px" fit="cover" :src="item" @click="preview(questionPic, index)" />
        </div>
<!--        <van-uploader v-model="questionPic" multiple :show-upload=false />-->
          <van-field v-model="inputForm.questionResource" rows="1" autosize label="整改要求" type="textarea" label-width='100px'
            placeholder="整改要求" readonly input-align="left" :border="false"/>
      </van-collapse-item>

      <van-collapse-item title="整改信息" name="3">
        <van-field v-model="inputForm.rectifyUserName" label="责任人" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="inputForm.rectifyStatus === '12'" v-model="inputForm.rectifyDate" label="整改期限" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-else v-model="inputForm.questionEndDate" label="整改期限" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
<!--        <van-field v-model="inputForm.taskUserName" label="原责任人" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>-->
          <van-field v-model="inputForm.rectifyResult" rows="2" autosize label="整改结果" type="textarea" placeholder="整改结果" label-width='100px'
            readonly input-align="left" :border="false" />
          <van-field label="整改图片" readonly />
          <div style="display: flex; padding-left: 16px">
            <van-image v-for="(item, index) in rectifyPic" :key="item.id" width="100px" height="100px" fit="cover" :src="item" @click="preview(rectifyPic, index)" />
          </div>
        <van-field v-if="inputForm.overtimeState === '1'" v-model="inputForm.overtimeTime" label="超时时间" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="inputForm.overtimeState === '1'" v-model="inputForm.overtimeReason" label="超时原因" readonly label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"/>

      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import QualityRectifyService from '@/api/quality/QualityRectifyService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {ImagePreview} from "vant";
import processRecord from "../../components/processRecord/processRecord";
export default {
  data() {
    return {
      questionPic: [
      ],
      rectifyPic: [
      ],

      dateinfo: '',
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        checkusername: '',
        scoreratio: '',
        standardName: '',
        frequency: '',
        levelname: '',
        id: '',
        projectId: '',
        projectName: '',
        customerId: '',
        customerName: '',
        houseId: '',
        houseName: '',
        feeItemNames: '',
        exchangeId: '',
        planMethod: '',
        planTypeName:'',
        dateOne: '',
        dateWeek: '',
        archiveMap: '',
        dateMonth: '',
        code: '',
        status: '',
        remarks: '',
        createDate: '',
        createByName: {
          id: ''
        },
        isDoTask: false,
        isLastTask: false,
        attachIds: [],
        attachList: [],
        taskList: [],
        reason: '',


      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  mounted() {
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(id)

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      new QualityRectifyService().queryQualityRectifyById(id).then(({ data }) => {

        this.inputForm = data
        if(this.inputForm.questionPic !== '') {
          this.questionPic = this.inputForm.questionPic.split('|')
        }
        if(this.inputForm.rectifyPic !== '') {
          this.rectifyPic = this.inputForm.rectifyPic.split('|')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new QualityRectifyService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
		  //更新数据库状态
		  _this.inputForm.flowType = 3;
		  new DeratedService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(arr, index){
      ImagePreview({
        images: arr,
        startPosition: index
      })
    }
  }
}
</script>
